var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('h1',[_vm._v("Loan Penalty Settings")])])])])
}]

export { render, staticRenderFns }